/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AlertSummary
 */
export interface AlertSummary {
    /**
     * 
     * @type {number}
     * @memberof AlertSummary
     */
    companyId: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertSummary
     */
    isOrderAlert: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertSummary
     */
    isMstCenterStockItemAlert: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertSummary
     */
    isMstItemAlert: boolean | null;
}

/**
 * Check if a given object implements the AlertSummary interface.
 */
export function instanceOfAlertSummary(value: object): value is AlertSummary {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('isOrderAlert' in value) || value['isOrderAlert'] === undefined) return false;
    if (!('isMstCenterStockItemAlert' in value) || value['isMstCenterStockItemAlert'] === undefined) return false;
    if (!('isMstItemAlert' in value) || value['isMstItemAlert'] === undefined) return false;
    return true;
}

export function AlertSummaryFromJSON(json: any): AlertSummary {
    return AlertSummaryFromJSONTyped(json, false);
}

export function AlertSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AlertSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'isOrderAlert': json['is_order_alert'],
        'isMstCenterStockItemAlert': json['is_mst_center_stock_item_alert'],
        'isMstItemAlert': json['is_mst_item_alert'],
    };
}

export function AlertSummaryToJSON(json: any): AlertSummary {
    return AlertSummaryToJSONTyped(json, false);
}

export function AlertSummaryToJSONTyped(value?: AlertSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'is_order_alert': value['isOrderAlert'],
        'is_mst_center_stock_item_alert': value['isMstCenterStockItemAlert'],
        'is_mst_item_alert': value['isMstItemAlert'],
    };
}

